import { createReducer, on } from '@ngrx/store';
import * as StatisticsActions from './statistics.action';
import { SaleFullViewingLogStatistcs, SaleViewingLogSummary } from 'src/app/models/statistics/statistics.model';
import { LookupModel } from '../../../models/common/lookup.model';

export interface StatisticsState {
  saleFullViewingLogStatistcs: SaleFullViewingLogStatistcs[];
  SaleFullViewingLogStatistcsLoaded: boolean;
  saleViewingSummary: SaleViewingLogSummary[];
  consignorSale: LookupModel[];
  consignorSaleLoaded: boolean;
  saleViewingSummaryLoaded: boolean;
  markAsArchived: boolean;
  success: any | null;
  error: any;
}

export const initialState: StatisticsState = {
  saleFullViewingLogStatistcs: [],
  SaleFullViewingLogStatistcsLoaded: false,
  saleViewingSummary: [],
  consignorSaleLoaded: false,
  consignorSale: [],
  saleViewingSummaryLoaded: false,
  markAsArchived: false,
  error: null,
  success: null,
};

export const statisticsReducer = createReducer(
  initialState,
  on(StatisticsActions.GetSaleFullViewingLogSuccess, (state, { saleFullViewingLogStatistcs }) => {
    return { ...state, saleFullViewingLogStatistcs: saleFullViewingLogStatistcs, SaleFullViewingLogStatistcsLoaded: true, error: null };
  }),
  on(StatisticsActions.GetSaleFullViewingLogFailure, (state, { err }) => ({ ...state, error: err })),
  on(StatisticsActions.GetSaleViewingSummarySuccess, (state, { saleViewingSummary }) => {
    return { ...state, saleViewingSummary: saleViewingSummary, saleViewingSummaryLoaded: true, error: null };
  }),
  on(StatisticsActions.GetSaleViewingSummaryFailure, (state, { err }) => ({ ...state, error: err })),

  on(StatisticsActions.getConsignorSales, (state) => ({ ...state, loading: true, error: null })),
  on(StatisticsActions.getConsignorSalesSuccess, (state, { sales }) => ({ ...state, consignorSale: sales, consignorSaleLoaded: true })),
  on(StatisticsActions.getConsignorSalesFailure, (state, { error }) => ({ ...state, error })),

  on(StatisticsActions.MarkAsArchive, (state) => ({ ...state, loading: true, error: null, markAsArchived: false })),
  on(StatisticsActions.MarkAsArchiveSuccess, (state, { response }) => ({ ...state, markAsArchived: true, success: response })),
  on(StatisticsActions.MarkAsArchiveFailure, (state, { err }) => ({ ...state, error: err, markAsArchived: false }))

);
